import auth from "./model/auth"
import system from "./model/system"
import org from "./model/org"
import promo from "./model/promo"
import order from "./model/order"

export default {
	auth,
	system,
	org,
	promo,
	order
}
